/**
 * Utilidades de formato numérico - un estándar por tipo de dato para toda la app.
 * Todas retornan '-' si el valor es null/undefined/NaN, evitando crashes de
 * `.toFixed()` sobre valores vacíos.
 */

const seguro = (valor: number | null | undefined): valor is number =>
  valor !== null && valor !== undefined && !Number.isNaN(valor);

/** Horas trabajadas: 1 decimal + "h" (ej. "7.8h") */
export const formatHoras = (valor: number | null | undefined): string =>
  seguro(valor) ? `${valor.toFixed(1)}h` : '-';

/** Área en hectáreas: 2 decimales + "ha" (ej. "12.34 ha") */
export const formatHectareas = (valor: number | null | undefined): string =>
  seguro(valor) ? `${valor.toFixed(2)} ha` : '-';

/** Longitud: recibe METROS, muestra en km con 2 decimales (ej. "1.23 km") */
export const formatKilometros = (metros: number | null | undefined): string =>
  seguro(metros) ? `${(metros / 1000).toFixed(2)} km` : '-';

/** Litros (combustible/insumos): 1 decimal + "L" (ej. "313.0L") */
export const formatLitros = (valor: number | null | undefined): string =>
  seguro(valor) ? `${valor.toFixed(1)}L` : '-';

/** Consumo específico: 1 decimal + "L/h" */
export const formatLitrosPorHora = (valor: number | null | undefined): string =>
  seguro(valor) ? `${valor.toFixed(1)}L/h` : '-';

/** Porcentaje: 1 decimal + "%" (ej. "5.3%") */
export const formatPorcentaje = (valor: number | null | undefined): string =>
  seguro(valor) ? `${valor.toFixed(1)}%` : '-';

/** Moneda CLP: sin decimales (el peso chileno no los usa) */
export const formatMoneda = (valor: number | null | undefined): string =>
  seguro(valor)
    ? new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0,
      }).format(valor)
    : '-';
